import { Box, useTheme, Typography, Button, TextField, getRadioUtilityClass } from "@mui/material";
import { tokens } from "../../theme";



import { useEffect, useState } from "react";
import { djangoApi } from "../../utils/axios/axios.utils";


import * as XLSX from "xlsx";
import CircularProgress from '@mui/material/CircularProgress';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';



const gridLayout = '40px 180px 180px 180px 180px 180px 180px 50px'
const TicketCodePage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [removingItems, setRemovingItems] = useState([]);

    const MySwal = withReactContent(Swal);

    const [isLoading, setIsLoading] = useState(false);
    const [dataToFilter, setDataToFilter] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [selectedItems, setSelectedItems] = useState([]);

    const [selectedValue, setSelectedValue] = useState('estoque');

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };




    const formatNumber = number => number?.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });



    const exportLabelsToExcel = (data) => {
        // Expand data based on quantity
        const expandedData = data.flatMap((item) =>
            Array.from({ length: item.quantity }, () => ({
                ID: item.id_produto,
                Tamanho: item.size,
                Cor: item.color === 'Ouro 18K' ? '' : item?.color?.toLowerCase(),
                Valor: `R$ ${Number(item.value).toFixed(2).replace('.', ',')}`,
            }))
        );


        const worksheet = XLSX.utils.json_to_sheet(expandedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Etiquetas");

        XLSX.writeFile(workbook, "etiquetas.xlsx");
    };


    const handlePrint = async () => {
        exportLabelsToExcel(selectedItems)
    };

    useEffect(() => {
        setIsLoading(true)
        const fetchData = async () => {
            try {
                const headers = {
                    Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                    "Content-Type": "application/json"
                };

                const [res1, res2] = await Promise.all([
                    djangoApi.get("products/register_prods/get_all_kitprods_open/", { headers }),
                    djangoApi.get("products/register_prods/get_prods_ajustes_preco/", {
                        headers,
                        params: {
                            should_return_other_prods: true // 👈 Add your query param here
                        }
                    })
                ]);

                // Pegando os dados dos dois
                const data1 = res1.data?.dados?.data || [];
                // console.log('data1', data1)
                const estoqueRes = res2.data?.dados
                // console.log('estoqueres', estoqueRes)
                const flattenGroupedData = Object.entries(estoqueRes).flatMap(
                    ([key, items]) =>
                        items.map(item => ({
                            ...item,
                            model: key
                        }))
                );
                const data2 = flattenGroupedData.map((data) => {
                    return (
                        {
                            "sell_price": data?.charged_price,
                            "kit__kit_number": 0,
                            "kit__pay_date": '',
                            "kit__seller__nome": "Pitaya Joias",
                            "content_type__model": data?.model,
                            "quantity": data?.quantity_available,
                            "pk": data?.pk,
                            "product_id_produto": data?.id_produto,
                            "product_tamanho": data?.tamanho ? data?.tamanho : 0,
                            "product_id_produto_color": data?.color__color
                        }
                    )
                })
                const changedPrice = res2?.data?.changed_prods
                // console.log('changed Prices : ', changedPrice)
                // Combinando
                // const combined = [...data1, ...data2];
                const combined = [...data2, ...data1];

                const finalArray = combined.map((data) => {
                    return (
                        {
                            value: data.sell_price,
                            id_produto: data.product_id_produto,
                            size: data.product_tamanho,
                            color: data.product_id_produto_color,
                            quantity: data.quantity,
                            model: data.content_type__model
                        }
                    )
                })

                const mergedArray = finalArray.reduce((acc, item) => {
                    const sizeAdjust = item.size ? item.size : 0
                    let key = ''
                    if (item.model === 'aneis') {
                        key = `${item.id_produto}-${sizeAdjust}-${item.color}`;
                    } else {
                        key = `${item.id_produto}-${item.color}`;
                    }

                    if (!acc[key]) {
                        // Make sure quantity is a number when first cloning
                        acc[key] = { ...item, quantity: Number(item.quantity) };
                    } else {
                        // Add up as numbers, not strings
                        acc[key].quantity += Number(item.quantity);
                    }


                    return acc;
                }, {});

                // Convert the object back to an array
                const combinedArray = Object.values(mergedArray);


                // console.log('combined data', combinedArray)

                // Step 1: Create a map for fast lookup
                const serverMap = Object.fromEntries(
                    changedPrice.map((item) => [item.id_produto, item])
                );

                // Step 2: Update the original array if matches found
                const updatedArray = combinedArray.map((item) => {
                    const match = serverMap[item.id_produto];
                    if (match) {
                        return {
                            ...item,
                            value: parseFloat(match.price),
                            quantity: match.quantity
                        };
                    }
                    return item;
                });

                setDataToFilter(updatedArray)

            } catch (error) {
                console.error("Erro ao buscar dados:", error);
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSearch = (value) => {
        setSearchQuery(value)
        if (value.length === 6) {
            let getResult = dataToFilter.find((data) => data.id_produto === value)
            if (getResult) {
                if (selectedValue === 'estoque') {
                    // KEEP LOGIC WHILE GETTING PRODS FROM INVENT
                    if (getResult.model === 'aneis') {
                        getResult = dataToFilter.filter((data) => data.id_produto === value)
                    }
                    if (selectedItems.find((data) => data.id_produto === value)) {
                        MySwal.fire("Ops!!", `Produto Já inserido ${value}`, "info").then(() => {
                            // Code to execute after the alert is confirmed
                            // For example, redirect to another page or refresh data
                        })
                    } else {
                        if (Array.isArray(getResult)) {
                            setSelectedItems((prev) => [...getResult, ...prev,]);
                        } else {
                            setSelectedItems((prev) => [getResult, ...prev]);
                        }
                        setSearchQuery("");
                    }
                } else {
                    // CHANGE HERE 
                    if (getResult.model === 'aneis') {
                        getResult = dataToFilter.find((data) => data.id_produto === value)
                        MySwal.fire({
                            title: "Atenção!!",
                            html: `Insira o tamanho do Anel`,
                            icon: "question",
                            input: "number",  // Input type set to 'number'
                            inputAttributes: {
                                min: 0,         // Minimum value
                                max: 100,       // Maximum value
                                step: 1         // Step increment
                            },
                            showCancelButton: true,
                            confirmButtonText: "Confirmar",
                            cancelButtonText: "Cancelar",
                            reverseButtons: true,
                            confirmButtonColor: colors.greenAccent[500],
                            cancelButtonColor: colors.yellow[600],
                            // customClass: {
                            //     confirmButton: styles['custom-confirm-button'],
                            //     cancelButton: styles['custom-cancel-button'],
                            //     actions: styles['custom-actions'],
                            // }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                const inputValue = Number(result.value); // The entered value is available in result.value
                                if (inputValue < 0 || inputValue > 100) {
                                    // Optionally validate again (SweetAlert already enforces min/max)
                                    console.error('Invalid value');
                                    return;
                                }
                                getResult = {
                                    ...getResult,
                                    size: inputValue,
                                    quantity: 1
                                };
                                if(getResult.model === 'aneis'){
                                    if (selectedItems.find((data) => data.id_produto === value && Number(data.size) === inputValue)) {
                                        MySwal.fire("Ops!!", `Produto Já inserido ${value}`, "info");
                                    } else {
                                        setSelectedItems((prev) => [getResult, ...prev]);
                                    }
                                } else {
                                    if (selectedItems.find((data) => data.id_produto === value)) {
                                        MySwal.fire("Ops!!", `Produto Já inserido ${value}`, "info");
                                    } else {
                                        setSelectedItems((prev) => [getResult, ...prev]);
                                    }
                                }
                                setSearchQuery("");
                            }
                        })
                    } else {
                        getResult = dataToFilter.find((data) => data.id_produto === value)
                        getResult = {
                            ...getResult,
                            quantity: 1
                        }
                        if (selectedItems.find((data) => data.id_produto === value)) {
                            MySwal.fire("Ops!!", `Produto Já inserido ${value}`, "info").then(() => {
                                // Code to execute after the alert is confirmed
                                // For example, redirect to another page or refresh data
                            })
                        } else {
                            setSelectedItems((prev) => [getResult, ...prev]);
                        }
                        setSearchQuery("");
                    }
                }
            } else {
                MySwal.fire("Ops!!", `Produto não encontrado: ${value}`, "error").then(() => {
                    // Code to execute after the alert is confirmed
                    // For example, redirect to another page or refresh data
                })
            }
        }
    }


    const handleRemove = (itemToRemove) => {
        const key = `${itemToRemove.id_produto}-${itemToRemove.size}-${itemToRemove.color}`;
        setRemovingItems(prev => [...prev, key]);

        // Wait for animation to finish, then remove from selectedItems
        setTimeout(() => {
            setSelectedItems(prev =>
                prev.filter(item =>
                    !(item.id_produto === itemToRemove.id_produto &&
                        item.size === itemToRemove.size &&
                        item.color === itemToRemove.color)
                )
            );
            setRemovingItems(prev => prev.filter(k => k !== key));
        }, 400); // match animation duration
    };

    if (isLoading) {
        return <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',  // Ensure it spans the entire width
                height: '100vh', // Use full viewport height for centering
            }}
        ><CircularProgress /></Box>
    }
    return (
        <Box
            mt={10}
            pl={4}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginRight: '20px',
                position: 'sticky',
                top: 50,
                zIndex: 10,
                paddingTop: '10px',
                paddingBottom: '20px',
                backgroundColor: colors.pink[500]
            }}>

                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: '60px' }}>

                    <TextField
                        variant="standard"
                        placeholder="Insira um ID"
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                        inputProps={{ maxLength: 6 }}
                        sx={{
                            width: "200px",
                            marginRight: "10px",
                            '& .MuiInput-underline:before': {
                                borderBottomColor: 'whitesmoke', // default
                            },
                            '& .MuiInput-underline:hover:before': {
                                borderBottomColor: 'rgba(153,153,153,0.2)', // hover
                            },
                            '& .MuiInput-underline:after': {
                                borderBottomColor: 'rgba(204,204,204,0.5)', // focus
                            },
                        }}
                    />
                    <FormControl component="fieldset">
                        {/* <FormLabel component="legend">Selecione uma Opção</FormLabel> */}
                        <RadioGroup value={selectedValue} onChange={handleChange} row>
                            <FormControlLabel value="estoque" control={<Radio color="success" />} label="Estoque" />
                            <FormControlLabel value="avulso" control={<Radio color="success" />} label="Avulso" />
                        </RadioGroup>
                    </FormControl>
                </Box>
                {
                    selectedItems && selectedItems.length > 0 && (
                        <Button
                            onClick={handlePrint}
                            variant="outlined"
                            color="inherit"
                            size="large"
                            startIcon={<FontAwesomeIcon icon={faFileExcel} />}
                        >
                            Download
                        </Button>
                    )
                }

            </Box>
            {
                selectedItems && selectedItems.length > 0 && (

                    <Box
                        sx={{
                            // marginTop: '20px',
                            position: 'sticky',
                            top: 115,
                            zIndex: 10,
                        }}
                    >
                        <Box

                            sx={{
                                display: 'grid',
                                gridTemplateColumns: gridLayout,
                                alignItems: 'center',
                                marginRight: '20px',
                                padding: '10px',
                                backgroundColor: colors.pink[800]
                            }}
                        >
                            <Typography sx={{ fontWeight: 'bold' }}>.</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>Tabela</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>ID Produto</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>Tamanho</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>Cor</Typography>
                            <Typography sx={{ fontWeight: 'bold', paddingLeft: '30px' }}>Quantidade</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>Preço</Typography>
                            <Box display="flex" alignItems="center" sx={{ justifyContent: 'center' }}>
                                <Typography sx={{ fontWeight: 'bold' }}>Ação</Typography>
                            </Box>
                        </Box>
                    </Box>
                )}
            {
                selectedItems && selectedItems.length > 0 && (
                    <Box>
                        {
                            selectedItems?.map((data, i) => {

                                const key = `${data.id_produto}-${data.size}-${data.color}`;
                                const isRemoving = removingItems.includes(key);
                                const rowHeight = 40; // define the actual row height used

                                return (
                                    <Box
                                        key={key}
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns: gridLayout,
                                            alignItems: 'center',
                                            marginRight: '20px',
                                            padding: '8px 10px',
                                            backgroundColor: i % 2 === 0 ? colors.pink[400] : undefined,
                                            animation: `${isRemoving ? 'collapseOut' : 'fadeInSlide'} 0.4s ease forwards`,
                                            overflow: 'hidden', // important to clip content during collapse
                                            height: isRemoving ? 0 : `${rowHeight}px`,
                                            '@keyframes fadeInSlide': {
                                                from: { opacity: 0, transform: 'translateY(-10px)' },
                                                to: { opacity: 1, transform: 'translateY(0)' },
                                            },
                                            '@keyframes collapseOut': {
                                                from: {
                                                    opacity: 1,
                                                    height: `${rowHeight}px`,
                                                    paddingTop: '8px',
                                                    paddingBottom: '8px',
                                                    marginBottom: '4px',
                                                },
                                                to: {
                                                    opacity: 0,
                                                    height: 0,
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    marginBottom: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <Typography>{selectedItems.length - i}</Typography>
                                        <Typography>{data.model}</Typography>
                                        <Typography>{data.id_produto}</Typography>
                                        <Typography>{data.size ? data.size : '-'}</Typography>
                                        <Typography>{data.color}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <IconButton
                                                onClick={() =>
                                                    setSelectedItems(prev =>
                                                        prev.map(item =>
                                                            item.id_produto === data.id_produto &&
                                                                item.size === data.size &&
                                                                item.color === data.color
                                                                ? {
                                                                    ...item,
                                                                    quantity: Math.max(1, (parseInt(item.quantity) || 1) - 1),
                                                                }
                                                                : item
                                                        )
                                                    )
                                                }
                                                size="small"
                                            >
                                                <RemoveIcon />
                                            </IconButton>
                                            <TextField
                                                type="number"
                                                variant="filled"
                                                size="small"
                                                value={data.quantity}
                                                inputProps={{ min: 1, style: { textAlign: 'center', width: 50, padding: '4px' } }}
                                                onChange={(e) => {
                                                    const newQuantity = Math.max(1, parseInt(e.target.value));
                                                    setSelectedItems(prev =>
                                                        prev.map(item =>
                                                            item.id_produto === data.id_produto &&
                                                                item.size === data.size &&
                                                                item.color === data.color
                                                                ? { ...item, quantity: newQuantity }
                                                                : item
                                                        )
                                                    );
                                                }}
                                                sx={{
                                                    mx: 1,
                                                    marginBottom: '12px',
                                                    width: 60,
                                                    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                        WebkitAppearance: 'none',
                                                        margin: 0,
                                                    },
                                                    '& input[type=number]': {
                                                        MozAppearance: 'textfield',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                            />

                                            <IconButton
                                                onClick={() =>
                                                    setSelectedItems(prev =>
                                                        prev.map(item =>
                                                            item.id_produto === data.id_produto &&
                                                                item.size === data.size &&
                                                                item.color === data.color
                                                                ? {
                                                                    ...item,
                                                                    quantity: Math.max(1, (parseInt(item.quantity) || 0) + 1),
                                                                }
                                                                : item
                                                        )
                                                    )
                                                }
                                                size="small"
                                            >
                                                <AddIcon />
                                            </IconButton>
                                        </Box>
                                        <Typography>R$ {formatNumber(data.value)}</Typography>
                                        <IconButton onClick={() => handleRemove(data)} color="warning">
                                            <DeleteIcon />
                                        </IconButton>

                                    </Box>
                                )
                            })
                        }
                    </Box>
                )
            }

            {/* <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 200px)',
                    gap: '25px',
                    columnGap: '75px'
                }}
            >
                {
                    printData.map((data, i) => {
                        return (
                            <Box
                                sx={{
                                    backgroundColor: 'white',
                                    border: '1px solid black',
                                    padding: '10px',
                                    paddingBottom: '0px',
                                    borderRadius: '20px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '250px'
                                }}
                            >
                                <Box>

                                    <Typography sx={{ color: 'black', textAlign: 'center' }}>R$ {formatNumber(data.value)}</Typography>
                                    <Barcode
                                        value={data.id_produto} // Match the number in your image
                                        format="CODE128" // You can also try "CODE39"
                                        displayValue={true}
                                        fontSize={14}
                                        height={100}
                                    />
                                </Box>
                                <Box sx={{ transform: "rotate(-90deg)", display: "flex", flexDirection: 'column', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                    <Typography sx={{ color: "black", textAlign: "center", fontWeight: 'bold', fontSize: '1.5em' }}>{data.size}</Typography>
                                    <Typography sx={{ color: "black", textAlign: "center", fontWeight: 'bold', fontSize: '1.2em' }}>{data.color}</Typography>
                                </Box>
                            </Box>
                        )
                    })
                }

            </Box> */}


        </Box>
    );
}

export default TicketCodePage;